import React, {Component} from 'react'

import styles from './FieldsGroup.less'

export default class FieldsGroup extends Component {
    render() {
        const {children} = this.props

        return (
            <div className={styles['group']}>{children}</div>
        )
    }
}